import React from 'react';
import distanceInWords from 'date-fns/distance_in_words';
import { Time } from './Time';

interface DateDistanceProps {
  /**
   * The date string to be displayed. Can be any valid date string parseable by Date.parse().
   */
  date: string;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * DateDistance component for displaying how long ago a date occurred.
 * Uses date-fns distance_in_words function to format the date.
 * @param props The component props.
 * @returns JSX.Element
 */
export const DateDistance: React.FC<DateDistanceProps> = ({ date, className }) => {
  const timestamp = Date.parse(date);
  const dateObject = new Date(timestamp);
  const now = new Date();
  const distance = distanceInWords(dateObject, now);
  const distanceText = `${distance} ago`;

  return (
    <Time date={date} className={className}>
      {distanceText}
    </Time>
  );
};
